import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const PickIcon = ({ iconName, color = "rgb(var(--color-primary))", ...props }) => {
  return <FontAwesomeIcon icon={iconName} color={color} {...props} />;
};

export default PickIcon;
